import React from "react";
import ContentLoader from "react-content-loader";

export default props =>{
    return <ContentLoader
        speed={2}
        viewBox="0 0 400 750"
        backgroundColor={'#eee'}
        foregroundColor={'#ccc'}
    >

        {/* order id & payment date */}
        <rect x="0" y="0" width="400" height="39" />
        <rect x="0" y="40" width="400" height="39" />

        {/* address */}
        <rect x="0" y="87" width="400" height="111" />

        {/* payment method */}
        <rect x="0" y="199" width="400" height="74" />

        {/* shipping method */}
        <rect x="0" y="281" width="400" height="37" />

        {/* items */}
        <rect x="0" y="326" width="400" height="157" />

        {/* order total */}
        <rect x="0" y="484" width="400" height="197" />

        {/* button */}
        <rect x="258" y="691" width="132" height="32" />

    </ContentLoader>
}